import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { speedingsQueryKeys } from "./queryKeys"
import { useSpeedingsQuery } from "./useSpeedingsQueries"

export function useSpeedings(parameters = {}, config = {}) {
    const url = "speeds/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = speedingsQueryKeys.layer(queryParameters)

    return useSpeedingsQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}

export function useSpeeding(speedingId, parameters = {}, config = {}) {
    const url = `speeds/${speedingId}/`
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = speedingsQueryKeys["feature"](speedingId, parameters)

    return useSpeedingsQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}